








import CheckBox from '@/views/atoms/CheckBox.vue'

export default
  components: {
    CheckBox
  }

  props:
    list:
      type: Array
      default: []
    name:
      type: String
      default: ''
    defaultNum: 
      type: String
      default: ''
    group:
      type: String
      default: null
    index:
      type: Number
      default: null
    valueName:
      type: Boolean
      default: false
    row:
      type: Object
    fileDownload:
      type: Boolean
      default: false
    disabled:
      type: Boolean
      default: false
    isPartner:
      type: Boolean
      default: false

  data: () ->
    ctrlName: ''
  created: () ->
    @ctrlName = @name + '_' + @index

  methods: {
    defaultCheck: (num) ->
      if parseInt(num, 10) == parseInt(@row.kind, 10)
        return true
      return false

    selectDefaultCheck: (num) ->
      if num == @defaultNum
        return true
      return false

    change: (e) ->
      @$emit('change', e)
  }
